import { createFileRoute, Link, redirect } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { useAuthStore } from '@/stores/auth';
import { AuthShell } from '@/components/layout/AuthShell';
import { LoginForm } from '@/features/auth/LoginForm';
import { bootstrapSession } from '@/api/client';

export const Route = createFileRoute('/login')({
  beforeLoad: async () => {
    await bootstrapSession();
    const status = useAuthStore.getState().status;
    if (status === 'authed') throw redirect({ to: '/dashboard' });
    if (status === 'pre_mfa' || status === 'needs_mfa') throw redirect({ to: '/mfa' });
  },
  component: LoginPage,
});

function LoginPage() {
  const { t } = useTranslation(['auth', 'common']);
  return (
    <AuthShell
      title={t('auth:login.title')}
      subtitle={t('auth:login.subtitle')}
      footer={
        <Link className="text-[color:var(--color-accent)] underline-offset-4 hover:underline" to="/forgot-password">
          {t('auth:login.forgot')}
        </Link>
      }
    >
      <LoginForm />
    </AuthShell>
  );
}
